import type * as models from './models'

import type { Feature } from './feature'

export class Selectors {
  public readonly toasts
  public readonly hasToasts
  public readonly getToast
  public readonly getToastAction

  constructor(feature: Feature) {
    this.toasts = feature.state.project(state => state.toasts)
    this.hasToasts = this.toasts.project(toasts => toasts.length > 0)

    this.getToast = feature.createSelectorMethod(
      ({ id }: { readonly id: models.Toast.Id }) =>
        this.toasts.project(toasts => toasts.find(toast => toast.id === id))
          .asSelector,
    )

    this.getToastAction = feature.createSelectorMethod(
      ({
        toastId,
        actionId,
      }: {
        readonly toastId: models.Toast.Id
        readonly actionId: models.Toast.Action['id']
      }) =>
        this.getToast({ id: toastId }).project(toast =>
          toast?.actions.find(action => action.id === actionId),
        ).asSelector,
    )
  }
}
